import React from "react";
import { Button } from "react-bootstrap";

const ReusableButton = ({ label, onClick }) => (
  <Button variant="primary" style={{ backgroundColor: "#813CCA", border: "none" }} onClick={onClick}>
    {label}
  </Button>
);

export default ReusableButton;
